import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NavigationLayout } from './@modules/layouts/navigation/navigation.component';

const routes: Routes = [
  {
    path: 'dashboard',
	component: NavigationLayout,
    loadChildren: () => import('./@modules/dashboard/dashboard.module').then(module => module.DashboardModule)
  },
  {
    path: 'session',
    data: {
      permission:''
    },
	loadChildren: () => import('./@modules/session/session.module').then(module => module.SessionModule)

  },
  {
    path: '',
    data: {
      permission:''
    },
	loadChildren: () => import('./@modules/session/session.module').then(module => module.SessionModule)
 },
 {
    path: 'companies',
    data: {
      permission:''
    },
	component: NavigationLayout,
	loadChildren: () => import('./@modules/companies/companies.module').then(module => module.CompaniesModule)
 },
 {
    path: 'tours',
    data: {
      permission:''
    },
	component: NavigationLayout,
	loadChildren: () => import('./@modules/tours/tours.module').then(module => module.ToursModule)
 },
 {
    path: 'bookings',
    data: {
      permission:''
    },
	component: NavigationLayout,
	loadChildren: () => import('./@modules/bookings/bookings.module').then(module => module.BookingsModule)
 },

 {
    path: 'reconciliation',
    data: {
      permission:''
    },
	component: NavigationLayout,
	loadChildren: () => import('./@modules/reconciliation/reconciliation.module').then(module => module.ReconciliationModule)
 },
 {
    path: 'scanner',
    data: {
      permission:''
    },
	component: NavigationLayout,
	loadChildren: () => import('./@modules/scanner/scanner.module').then(module => module.ScannerModule)
 },
  {
    path: 'user',
    data: {
      permission:''
    },
   component: NavigationLayout,
	loadChildren: () => import('./@modules/user/user.module').then(module => module.UserModule)

  },
  {
    path: 'profile',
    data: {
      permission:''
    },
    component: NavigationLayout,
    loadChildren: () => import('./@modules/profile/profile.module').then(module => module.ProfileModule)
  },
  {
    path: 'accounts',
    data: {
      permission:''
    },
    component: NavigationLayout,
    loadChildren: () => import('./@modules/accounts/accounts.module').then(module => module.AccountsModule)
  },
  {
    path: 'settings',
    data: {
      permission:''
    },
    component: NavigationLayout,
    loadChildren: () => import('./@modules/settings/settings.module').then(module => module.SettingsModule)
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  exports: [
    RouterModule
  ],
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled'
    })
  ]
})
export class AppRoutingModule { }
